import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagInvalidResult = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", { d: "m0 0h20v20h-20z" })
	}), /* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "m15.625 10c.0007 1.2758-.4343 2.5136-1.2328 3.5086l-7.90079-7.90079c.82698-.6619 1.82415-1.07667 2.8766-1.1965 1.05249-.11983 2.11739.06016 3.07199.51921.9546.45906 1.7601 1.1785 2.3236 2.07542s.8621 1.93481.8614 2.99406zm-11.25 0c-.00069 1.0592.29793 2.0971.86144 2.9941.56352.8969 1.36899 1.6163 2.3236 2.0754.95461.459 2.0195.639 3.07196.5192 1.0524-.1198 2.0496-.5346 2.8766-1.1965l-7.90078-7.90079c-.79856.99498-1.23349 2.23278-1.23282 3.50859zm14.0625 0c0 1.6688-.4948 3.3001-1.422 4.6876-.9271 1.3876-2.2449 2.469-3.7866 3.1076-1.5418.6386-3.23826.8057-4.87497.4802-1.63672-.3256-3.14013-1.1292-4.32014-2.3092-1.18-1.18-1.9836-2.6834-2.30916-4.3201s-.15847-3.33324.48014-4.87499 1.72007-2.85951 3.10761-3.78663c1.38754-.92713 3.01884-1.42198 4.68762-1.42198 2.237.00248 4.3817.89223 5.9635 2.47403s2.4715 3.72647 2.474 5.96347zm-1.5625 0c0-1.35975-.4032-2.68896-1.1586-3.81955-.7555-1.13058-1.8292-2.01177-3.0854-2.53212-1.2563-.52035-2.63862-.6565-3.97224-.39123s-2.55863.92006-3.52012 1.88154c-.96148.96149-1.61626 2.18649-1.88153 3.52011-.26528 1.33362-.12913 2.71595.39122 3.97215.52035 1.2563 1.40154 2.33 2.53213 3.0855 1.13059.7554 2.4598 1.1586 3.81954 1.1586 1.8227-.0021 3.5702-.7271 4.8591-2.0159 1.2888-1.2889 2.0138-3.0364 2.0159-4.8591z",
			fill: "current"
		})
	})]
});
export default SvgFlagInvalidResult;
